import React from 'react';
import { set } from 'dot-prop-immutable';
import { toolFormAttr, toolCollapseAttr, getLocale } from '@utils/util';
import { SimpleForm as Form, Collapse } from '@whalecloud/fdx';
import CustomInput from '@whalecloud/page-builder-base-components/components/CustomInput';
import CommonItemSettings from '@whalecloud/page-builder-base-components/components/ElementSettings/CommonItemSettings';
import DefaultValueTable from './DefaultValueTable';

const { Panel } = Collapse;

const valueKey = 'data.formItemSettings';

const PopEditSettings = (props: any) => {
  const messages = getLocale();
  
  const { updateElement, element } = props;
  const { data: { formItemSettings = {} } = {} } = element;

  const {
    dataTextField = 'name',
    dataValueField = 'value',
    modalProps,
    inputProps,
  } = formItemSettings;

  const perWidth = Math.round((modalProps?.width / document.body.clientWidth) * 100);
  const perHeight = Math.round(((modalProps?.bodyStyle?.height + 81.6) / document.body.clientHeight) * 100);

  const initialValues = {
    dataTextField,
    dataValueField,
    // componentURL,
    'inputProps.placeholder': inputProps?.placeholder,
    'modalProps.title': modalProps?.title,
    'modalProps.width': perWidth || 50,
    'modalProps.bodyStyle.height': perHeight || 70,
    'modalProps.render': modalProps.render || 'https://fish.iwhalecloud.com/remote-components/popeditmodal.js',
  };

  const onFormChange = (obj: Object) => {
    Object.keys(obj).forEach((key: string) => {
      const propName = `${valueKey}.${key}`;
      let value = obj[key];
      if (key === 'modalProps.width') {
        value = (value / 100) * document.body.clientWidth;
      }
      if (key === 'modalProps.bodyStyle.height') {
        value = (value / 100) * document.body.clientHeight - 81.6;
      }
      const newElement = set(element, propName, value);
      updateElement({
        element: newElement,
      });
    });
  };
  return (
    <Collapse {...toolCollapseAttr} defaultActiveKey={['1', '2']}>
      <Panel header={messages.PAGEBUIDER_SETTINGS} key="1">
        <CommonItemSettings allowClearHide placeholderHide defaultValueHide />
        <Form {...toolFormAttr} initialValues={initialValues} onValuesChange={onFormChange}>
          <Form.Item label={messages.PAGEBUIDER_SETTINGS_PLACE_HOLDER} name="inputProps.placeholder">
            <CustomInput inputProps={{ placeholder: messages.PAGEBUIDER_SETTINGS_PLACEHOLDER_PLACEHOLDER }} />
          </Form.Item>
          <Form.Item label={messages.PAGEBUIDER_SETTINGS_DATATEXTFIELD} name="dataTextField">
            <CustomInput />
          </Form.Item>
          <Form.Item label={messages.PAGEBUIDER_SETTINGS_DATAVALUEFIELD} name="dataValueField">
            <CustomInput />
          </Form.Item>
          <Form.Item label={messages.PAGEBUIDER_SETTINGS_PAGE_URL} name="modalProps.render">
            <CustomInput inputProps={{ placeholder: 'Modify the inner component of Modal' }} />
          </Form.Item>
          <Form.Item label={messages.PAGEBUIDER_SETTINGS_TITLE} name="modalProps.title">
            <CustomInput />
          </Form.Item>
          <Form.Item label={messages.PAGEBUIDER_SETTINGS_MODAL_WIDTH} name="modalProps.width">
            <CustomInput
              inputType="inputNumber"
              inputProps={{
                min: 0,
                max: 100,
                formatter: value => value ? `${value}%` : '',
                parser: value => value.replace('%', ''),
              }}
            />
          </Form.Item>
          <Form.Item label={messages.PAGEBUIDER_SETTINGS_MODAL_HEIGHT} name="modalProps.bodyStyle.height">
            <CustomInput
              inputType="inputNumber"
              inputProps={{
                min: 0,
                max: 100,
                formatter: value => value ? `${value}%` : '',
                parser: value => value.replace('%', ''),
              }}
            />
          </Form.Item>
        </Form>
      </Panel>
      <Panel header={messages.PAGEBUIDER_SETTINGS_DEFAULT_VALUE_SET} key="2">
        <DefaultValueTable element={element} updateElement={updateElement} />
      </Panel>
    </Collapse>
  );
};

export default PopEditSettings;
